import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen relative overflow-hidden" }
const _hoisted_2 = { class: "relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8" }
const _hoisted_3 = { class: "w-full max-w-2xl" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_6 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_7 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_8 = { class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-6" }
const _hoisted_9 = { class: "text-lg text-red-700 dark:text-red-300" }
const _hoisted_10 = {
  key: 3,
  class: "space-y-6"
}

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { emailVerificationService } from '@/services/api/emailVerificationService'

const backgroundImage = '/src/assets/images/tire-bg2.webp'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailVerificationView',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const loading = ref(false)
const success = ref(false)
const error = ref('')
let redirectTimeout: number | null = null

onMounted(async () => {
  const token = route.query.token as string

  if (!token) {
    return
  }

  loading.value = true

  try {
    await emailVerificationService.verifyEmail(token)
    success.value = true
    
    redirectTimeout = window.setTimeout(() => {
      goToLogin()
    }, 3000)
  } catch (err: any) {
    error.value = err.response?.data?.message || 'An error occurred during verification.'
  } finally {
    loading.value = false
  }
})

const goToLogin = () => {
  if (redirectTimeout) {
    clearTimeout(redirectTimeout)
  }
  router.push('/')
}

const goToHome = () => {
  router.push('/')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute inset-0 bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: `url(${backgroundImage})` })
    }, null, 4),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-70" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "flex justify-center" }, [
                  _createElementVNode("div", { class: "animate-spin rounded-full h-16 w-16 border-b-2 border-white" })
                ], -1),
                _createElementVNode("h2", { class: "text-3xl font-bold text-white" }, "Verifying your email...", -1),
                _createElementVNode("p", { class: "text-lg text-gray-300" }, "Please wait while we verify your account.", -1)
              ])))
            : (success.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"flex justify-center\"><div class=\"rounded-full bg-green-500 p-6\"><svg class=\"w-16 h-16 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5 13l4 4L19 7\"></path></svg></div></div><h2 class=\"text-3xl font-bold text-white\">Email verified successfully!</h2><p class=\"text-lg text-gray-300\"> Your account is now active. You can log in to access your account. </p>", 3)),
                  _createElementVNode("div", { class: "flex justify-center" }, [
                    _createElementVNode("button", {
                      onClick: goToLogin,
                      class: "px-12 py-3 bg-blue-600 text-white text-xl font-medium rounded-full hover:bg-blue-700 transition-colors"
                    }, " Go to Login ")
                  ])
                ]))
              : (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"flex justify-center\"><div class=\"rounded-full bg-red-500 p-6\"><svg class=\"w-16 h-16 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 18L18 6M6 6l12 12\"></path></svg></div></div><h2 class=\"text-3xl font-bold text-white\">Verification failed</h2>", 2)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(error.value), 1)
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-lg text-gray-300" }, [
                      _createTextVNode(" Please go to the login page and use the "),
                      _createElementVNode("strong", { class: "text-white" }, "\"Resend Verification Email\""),
                      _createTextVNode(" button to get a new link. ")
                    ], -1)),
                    _createElementVNode("div", { class: "flex justify-center gap-4" }, [
                      _createElementVNode("button", {
                        onClick: goToHome,
                        class: "px-12 py-3 bg-gray-600 text-white text-xl font-medium rounded-full hover:bg-gray-700 transition-colors"
                      }, " Go to Login ")
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"flex justify-center\"><div class=\"rounded-full bg-yellow-500 p-6\"><svg class=\"w-16 h-16 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z\"></path></svg></div></div><h2 class=\"text-3xl font-bold text-white\">No verification token found</h2><p class=\"text-lg text-gray-300\"> Please check your email and click the verification link. </p>", 3)),
                    _createElementVNode("div", { class: "flex justify-center" }, [
                      _createElementVNode("button", {
                        onClick: goToHome,
                        class: "px-12 py-3 bg-gray-600 text-white text-xl font-medium rounded-full hover:bg-gray-700 transition-colors"
                      }, " Go to Home ")
                    ])
                  ]))
        ])
      ])
    ])
  ]))
}
}

})